import { JSX } from "preact/jsx-runtime";
import { useModal } from "../../shared/contexts";
import { Box, Typography } from "../../shared/ui";
import { Icon } from "../Icon";
import css from "./Navigation.module.scss";

interface NavigationProps {
  title?: string;
  onClose?: () => void;
  badge?: JSX.Element;
}

export const Navigation = ({
  title = "Navigation",
  onClose,
  badge,
}: NavigationProps) => {
  const { closeModal } = useModal();

  const handleClose = () => {
    if (onClose) {
      onClose();
    }
    closeModal();
  };

  return (
    <>
      <div className={css.container}>
        <Box
          className={css.wrapper}
          align="center"
          display="flex"
          justify="between"
        >
          <div className={css.backButton} />
          <div className={css.titleWrapper}>
            <Typography className={css.text} color="header">
              {title}
            </Typography>
            {badge}
          </div>

          <button className={css.closeBtn} onClick={handleClose} type="button">
            <Icon name="close" width={20} height={20} color="#707071" />
          </button>
        </Box>
      </div>
    </>
  );
};
